import React from "react";

import { GetStaticProps } from "next";
import { PreviewSuspense } from "next-sanity/preview";

import { LazyPreviewPage } from "../../page/LazyPreviewPage";
import { LoadingScreen } from "../../page/LoadingScreen";
import { PAGE_DATA_QUERY, PAGE_PATHS_QUERY } from "../../page/query";
import { PageData } from "../../page/types";
import { client } from "../../sanity/client";

import { EstimationPage } from "../../page/EstimationPage";
import { GuideDuCredit } from "../../page/GuideDuCredit";
import { groq } from "next-sanity";

interface PageProps {
  savoirPlus: PageData | null;
  ComprendrePosts: PageData | null;
  AvantLancerPosts: PageData | null;
  Articles: PageData | null;

  data: PageData | null;
  preview: boolean;
  slug?: string | null;
  token: string | null;
}

interface Query {
  [key: string]: string;
}

interface PreviewData {
  token?: string;
}

const querySavoirPlusPosts = groq`*[_type == "guidePost" && "Pour en savoir plus" in categories[]->title][0..2]`;
const queryComprendrePosts = groq`*[_type == "guidePost" && "Tout comprendre au crédit immobilier" in categories[]->title][0..2]`;
const queryAvantLancerPosts = groq`*[_type == "guidePost" && "Avant de se lancer" in categories[]->title][0..2]`;
const articles_query = groq`*[_type == "guidePost" && ready_to_be_on_guide == true] | order(_updatedAt desc) {
  ...,
  "author":author->{
      ...,
  },
}`;

export const getStaticProps: GetStaticProps<
  PageProps,
  Query,
  PreviewData
> = async (ctx) => {
  let { params = {}, preview = false, previewData = {} } = ctx;
  params.slug = "guide-du-credit";
  if (preview && previewData.token) {
    return {
      props: {
        data: null,
        savoirPlus: null,
        ComprendrePosts: null,
        AvantLancerPosts: null,
        Articles: null,
        preview,
        slug: "guide-du-credit",
        token: previewData.token,
      },
    };
  }

  const data = await client.fetch<PageData | null>(PAGE_DATA_QUERY, params);
  const savoirPlus = await client.fetch<PageData | null>(
    querySavoirPlusPosts,
    params
  );
  const ComprendrePosts = await client.fetch<PageData | null>(
    queryComprendrePosts,
    params
  );
  const AvantLancerPosts = await client.fetch<PageData | null>(
    queryAvantLancerPosts,
    params
  );
  const Articles = await client.fetch(articles_query);

  return {
    props: {
      data,
      savoirPlus,
      ComprendrePosts,
      AvantLancerPosts,
      preview,
      slug: params?.slug.replace("/fr", "").replace("/ar", "") || null,
      token: null,
      Articles,
    },
  };
};

export default function Page(props: PageProps) {
  const {
    data,
    savoirPlus,
    ComprendrePosts,
    AvantLancerPosts,
    preview,
    token,
    Articles,
  } = props;

  if (preview) {
    return (
      <PreviewSuspense
        fallback={<LoadingScreen>Loading preview…</LoadingScreen>}
      >
        <LazyPreviewPage slug={"guide-du-credit"} token={token} />
      </PreviewSuspense>
    );
  }
  return <GuideDuCredit data={data} Articles={Articles} />;
}
